import React, { useState, useEffect } from "react";
import LiquidContainer from "../../components/LiquidContainer";
import MainLanding from "./MainLanding";
import RankingsCard from "../../components/RankingsCard"; // Ensure this is imported
import { getRankings } from '../../api/user';

const Rankings = () => {
  // 1. State for Filters
const [filters, setFilters] = useState({
  sport: "",
  gender: "",
  level: "" // Empty string to show all categories initially
});

  // 2. State for Data & UI
  const [rankingsData, setRankingsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 1. Add this new state at the top
const [hasSelected, setHasSelected] = useState(false);

// 2. Update your handleChange to flip that switch
const handleChange = (e) => {
  const { name, value } = e.target;
  setFilters((prev) => ({ ...prev, [name]: value }));
  setHasSelected(true); // Now we know the user is looking for something specific
};


const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // These keys MUST match your Django View request.query_params.get()
      const payload = {
        activity: filters.sport,   // Changed from sport_type
        sex: filters.gender,       // Changed from gender
        category: filters.level,   // Changed from skill_level
      };

      console.log('Rankings request payload:', payload);

      const result = await getRankings(payload);
      
      // Store the response
      // result.data if using axios, result if using a custom fetch wrapper
      setRankingsData(result); 
      
      console.log('Rankings results successfully set:', result.data || result);
      
    } catch (err) {
      console.error("🔥 Backend error:", err);
      setError("Error al obtener el ranking. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
};

  // Optional: Trigger fetch automatically when filters change
  useEffect(() => {
    handleSubmit();
  }, [filters]);

  return (
    <MainLanding>
      <LiquidContainer
        backgroundColor="#efefefe0"
        ancho="95vw"
        alto="75vh"
        borderline="0px"
        boxSdw="none"
      >
        <div className="contenedor m-0 p-0 d-block" style={{ height: "90%", width: "90%"}}>
            <div className="row m-0 p-0">
            <div className="col m-0 p-0">

                <form onSubmit={handleSubmit} className="p-1">
                    <div className="row g-3 mb-2">
                        {/* Dropdown 1: Sport */}
                        <div className="col-md-4 my-1">
                        <label className="form-label fw-bold">DEPORTE</label>
                        <select name="sport" className="form-select" onChange={handleChange} value={filters.sport}>
                            <option value="">Todas</option>
                            <option value="SKI">Esquí</option>
                            <option value="SNOWBOARD">Snowboard</option>
                        </select>
                        </div>

                        {/* Dropdown 2: Gender */}
                        <div className="col-md-4 my-1">
                        <label className="form-label fw-bold">CATEGORÍA</label>
                        <select name="gender" className="form-select" onChange={handleChange} value={filters.gender}>
                            <option value="">Todos</option>
                            <option value="M">Masculino</option>
                            <option value="F">Femenino</option>
                        </select>
                        </div>

                        {/* Dropdown 3: Level */}
                        {/* Rankings.js */}
                        <div className="col-md-4 my-1">
                        <label className="form-label fw-bold">NIVEL</label>
                        <select name="level" className="form-select" onChange={handleChange} value={filters.level}>
                        <option value="">Todos los niveles</option>
                            {/* These values will now be searched inside the 'category_name' string */}
                            <option value="Principiantes">AVANZADO</option>
                            <option value="Intermedios">MEDIO</option>
                            <option value="Avanzados">PRINCIPIANTE</option>
                        </select>
                        </div>
                    </div>
                </form>
            </div>
        </div>


        {/* 3. Render Rankings results */}
        {loading ? (
        <div className="text-center p-5 pt-0">Cargando rankings...</div>
        ) : error ? (
        <div className="alert alert-danger">{error}</div>
        ) : (
        <div className="ranking-results-container" style={{ overflowY: 'auto', maxHeight: '50vh' }}>
            
            {/* Display Category Title if data exists */}
{/* Only show the category header if the user has actually picked something */}
{hasSelected && rankingsData.length > 0 && (
  <div className="mb-3 px-2">
    {/* <h5 className="text-uppercase text-muted small">Categoría:</h5>
    <h5 className="text-uppercase fw-bold">
      {rankingsData[0]?.category_name || ""}
    </h5> */}
  </div>
)} 

            {/* Pass the data to your card component */}
            <RankingsCard data={rankingsData} />
        </div>
        )}
        </div>
        
      </LiquidContainer>
    </MainLanding>
  );
};

export default Rankings;